import { useRef, useEffect, useCallback, PropsWithChildren, FC, useState, useMemo } from 'react'
import { Spin } from 'antd'
import { Column } from '@antv/g2plot';
import Card from '@/pages/Tbqy/components/components/Card'
import * as api from '@/api/tbyqy'
import styles from '@/pages/Tbqy/style.module.less'

const data = [];

for(let i=0; i<12; i++) {
  data.push({
    "label": i+ 1 + "月",
    "type": "今年",
    "value": 0
  })
  data.push({
    "label": i+ 1 + "月",
    "type": "去年",
    "value": 0
  })
}

type PropType = FC<PropsWithChildren<{
  updateTime: string
}>>

const tabsOptions = [
  {
    label: '投标',
    value: 'TByearnum',
    api: api.getTbsjtjAsjTb,
    totalText: '投标总数'
  }, 
  {
    label: '中标', 
    value: 'ZByearnum',
    api: api.getTbsjtjAsjZb,
    totalText: '平均中标率'
  }
]

const Component: PropType = ({updateTime}) => {
  const [loading, setLoading] = useState(false)
  const containerRef = useRef()
  const [title, setTitle] = useState(tabsOptions[0].label)
  const globalRef = useRef({
    activeTab: tabsOptions[0].value,
    column: null as Column
  })
  const [total, setTotal] = useState({
    jn: 0,
    qn: 0
  })

  useEffect(() => {
    globalRef.current.column = new Column(containerRef.current, {
      data: [],
      xField: 'label',
      yField: 'value',
      seriesField: 'type',
      isGroup: true,
      legend: {
        position: 'bottom',
      },
      columnStyle: {
      },
    });

    globalRef.current.column.render();
  }, [])

  // 获取图表数据
  const getColumnData = useCallback(async () => {
    const tabOption = tabsOptions.find(t => t.value === globalRef.current.activeTab)
    if(!tabOption) {
      return
    }
    const res = await tabOption.api()
    if(res.success) {
      if('TByearnum' === globalRef.current.activeTab) {
        const TBnum = res.data.TBnum[0] || {}
        setTotal({
          jn: TBnum.jnTBnum,
          qn: TBnum.qnTBnum
        })
      } else if('ZByearnum' === globalRef.current.activeTab) {
        const TBnum = res.data.ZBrate[0] || {}
        setTotal({
          jn: TBnum.jnRate,
          qn: TBnum.qnRate
        })
      }

      globalRef.current.column.changeData(res.data.list.reduce((c, n) => {
        c.push({
          label: n.time,
          value: n.jnZBnum || n.jnTBnum || 0,
          type: '今年'
        })
        c.push({
          label: n.time,
          value: n.qnZBnum || n.qnTBnum || 0,
          type: '去年'
        })
        return c
      }, []))
    }
  }, [])

  // 获取接口数据
  const getList = useCallback(async () => {
    setLoading(true)
    Promise.all([getColumnData()]).finally(() => {
      setLoading(false)
    })
  }, [getColumnData])

  // 变更类型
  const handleTabChange = useCallback((value) => {
    globalRef.current.activeTab = value
    const tabOption = tabsOptions.find(t => t.value === value)
    setTitle(tabOption ? tabOption.totalText : '')
    getList()
  }, [getList])

  useEffect(() => {
    getList()
  }, [updateTime, getList])

  return (
    <Spin spinning={loading}>
      <Card 
        title="投标数据统计（按时间）"
        tabs={tabsOptions}
        onTabChange={handleTabChange}
      >
        <div className={`flex ${styles['tb-sj']}`}>
          {
            title && (
              <div className={`text-center ${styles['tb-sj-left']}`}>
                <div className='text-777 mt-30'>本年{title}</div>
                <div className='font-30 text-primary mt-7'>{total.jn}</div>
                <div className='text-777 mt-30'>上年{title}</div>
                <div className='font-30 mt-7'>{total.qn}</div>
              </div>
            )
          }
          <div className='flex-1 w-0 ml-10'>
            <div className='h-full' ref={containerRef}></div>
          </div>
        </div>
      </Card>
    </Spin>
  )
}

export default Component
